import { Button } from "@/components/ui/button";

const AboutSection = () => {
  return (
    <section id="about" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">About Wii Seng Technology Resources</h2>
            
            <div className="space-y-4 mb-8">
              <p className="text-wiiseng-gray">
                Based in Kota Kemuning, Shah Alam, Wii Seng Technology Resources services and repairs
                precision CNC machines and manufacturing equipment for workshops and manufacturers across
                Selangor and the Klang Valley — from routine maintenance and troubleshooting to
                retrofitting, calibration, and spindle repair.
              </p>
              
              <p className="text-wiiseng-gray">
                Our engineers work directly with your shop to diagnose issues, fix what's broken, and keep
                your CNC machines running reliably with minimal downtime.
              </p>
              
              <div className="pt-2">
                <h3 className="text-xl font-semibold mb-2">Wii Seng Technology Resources</h3>
                <p className="text-wiiseng-gray">
                  专注于精密 CNC 机床及制造设备的维护、维修与优化服务。无论是 CNC 系统、车床、铣床还是工业自动化设备，
                  我们都能提供可靠的维修与保养方案，帮您减少停机时间。
                </p>
              </div>
            </div>
            
          </div>
          
          <div className="bg-wiiseng-navy/10 p-8 rounded-lg">
            <h3 className="text-2xl font-bold mb-6 text-wiiseng-navy">Our Expertise</h3>
            
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="bg-wiiseng-blue rounded-full p-1 mr-3 mt-1">
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                  </svg>
                </div>
                <div>
                  <p className="font-medium">Repair & servicing of multi-axis CNC mills, lathes, grinders & EDM machines</p>
                  <p className="text-sm text-wiiseng-gray">多轴 CNC 铣床、车床、磨床和电火花机的维修与保养</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-wiiseng-blue rounded-full p-1 mr-3 mt-1">
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                  </svg>
                </div>
                <div>
                  <p className="font-medium">Retrofitting, calibration, and spindle repair</p>
                  <p className="text-sm text-wiiseng-gray">机床改造、校准和主轴维修</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-wiiseng-blue rounded-full p-1 mr-3 mt-1">
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                  </svg>
                </div>
                <div>
                  <p className="font-medium">Diagnostics and preventive maintenance</p>
                  <p className="text-sm text-wiiseng-gray">诊断和预防性维护</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-wiiseng-blue rounded-full p-1 mr-3 mt-1">
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                  </svg>
                </div>
                <div>
                  <p className="font-medium">System optimization for minimal downtime</p>
                  <p className="text-sm text-wiiseng-gray">系统优化，减少停机时间</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
